import 'css/src/components/public-pages/Page404';

import React from 'react';

const PageTermsGetty = React.memo(function PageTermsGetty() {
    return (
        <section style={{ marginTop: '140px' }}>
            <div className="container">
                <div className="page" title="Page 2">
                    <div className="section">
                        <div className="layoutArea">
                            <div className="column">
                                <h3 className="mt-l5-48">
                                    Additional Terms for Use of Media Provided by Getty Images, Inc.
                                </h3>
                                <div className="font-l5 font-l5--regular">
                                    You may only use Media Provided by Getty Images, Inc. (&quot;
                                    <strong>Licensed Material</strong>&quot;) in videos created via
                                    the Lumen5 Service, for display solely in digital form.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    You may not sell, modify, re-use, re-sell, distribute, display,
                                    reproduce or make any other use of Licensed Material.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    Licensed Material may not be used:
                                </div>
                                <ol>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            on a stand-alone basis with no other content;
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            for pornographic, defamatory or other unlawful purposes;
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            in electronic templates used to create electronic or
                                            printed products;
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            in physical or digital retail products, such as e-cards,
                                            calendars, posters, or screensavers;
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            for the purpose of enabling file-sharing of the image
                                            file; or
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            in logos, trademarks, services marks or any other
                                            branding or identifiers.
                                        </div>
                                    </li>
                                </ol>
                                <div className="font-l5 font-l5--regular">
                                    If Licensed Material featuring an individual(s) is used in
                                    connection with a sensitive, unflattering, or controversial
                                    subject, you must include a statement that the image is used for
                                    illustrative purposes only and the individual is a model.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    You may not activate the &quot;right-click&quot; function in
                                    Licensed Material, remove any metadata in Licensed Material, or
                                    reverse engineer, decompile, or disassemble the Lumen5 Services
                                    to enable the download or use of Licensed Material on a
                                    stand-alone basis.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    No ownership or copyrights to Licensed Material are granted to
                                    you.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default PageTermsGetty;
